import React from 'react';
import { BookOpen, HelpCircle, KeyRound, LifeBuoy, ShieldCheck } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../ui/dialog';

/**
 * Les pop-ups de la page de connexion : aide, conditions d'utilisation,
 * confidentialité, mot de passe oublié, support.
 *
 * Titre et contenu viennent du CIK. Le contenu est du texte brut — les sauts de
 * ligne sont conservés, rien n'est interprété comme du HTML.
 *
 * `couleur` : le bleu de l'administration par défaut. Les pages de l'espace
 * famille passent leur vert, pour que la pop-up appartienne visiblement à la
 * page qui l'ouvre.
 */
const ICONES = {
  aide: HelpCircle,
  cgu: BookOpen,
  confidentialite: ShieldCheck,
  mot_de_passe: KeyRound,
  support: LifeBuoy
};

const PopupConnexion = ({ cle, popup, onClose, couleur = '#246990', couleurSurvol = '#1f5a7a' }) => {
  const Icone = ICONES[cle] || HelpCircle;
  return (
    <Dialog open={Boolean(cle)} onOpenChange={(ouvert) => { if (!ouvert) onClose(); }}>
      <DialogContent className="w-[95vw] max-w-3xl !max-h-[92vh] overflow-hidden flex flex-col p-0 gap-0">
        <DialogHeader className="flex-row items-center gap-3 space-y-0 border-b px-5 py-4 text-left">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg text-white" style={{ background: couleur }}>
            <Icone size={18} />
          </div>
          <div className="min-w-0">
            <DialogTitle className="text-lg font-semibold text-gray-900">{popup?.titre}</DialogTitle>
            <DialogDescription className="text-sm text-gray-500">KLASYS</DialogDescription>
          </div>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          <p className="whitespace-pre-line text-sm leading-relaxed text-gray-700">
            {popup?.contenu}
          </p>
        </div>

        <DialogFooter className="border-t bg-gray-50 px-5 py-4">
          {/* 44 px sur écran tactile (tablette, téléphone) ; à la souris, 36 px comme avant. */}
          <Button
            type="button"
            onClick={onClose}
            className="h-9 min-w-[168px] justify-center gap-2 border border-transparent text-white [@media(pointer:coarse)]:h-11"
            style={{ background: couleur }}
            onMouseEnter={(e) => { e.currentTarget.style.background = couleurSurvol; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = couleur; }}
          >
            Fermer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PopupConnexion;
